<template>
  <div>
    <form-wizard color="#0D3A6D" :title="null" :subtitle="null" shape="square" finish-button-text="Valider"
      back-button-text="Précédent" next-button-text="Suivant" class="mb-3" @on-complete="formSubmitted">
      <!-- Choix du client -->
      <tab-content title="Choix du client" :before-change="validationClient">
        <validation-observer ref="simpleRules">
          <b-row>
            <b-col cols="12" md="4" class="mb-2">
              <b-form-group label="Date de livraison souhaitée :" label-for="dateliv">
                <validation-provider #default="{ errors }" name="datelivstate" rules="required">
                  <flat-pickr id="dateliv" ref="dateliv" v-model="$invoice.datelivraison" :config="config"
                    :state="errors.length > 0 ? false : null" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="8" class="mb-2">
              <b-form-group label="Clients :" label-for="vi-client">
                <v-select v-model="selectedClient" :options="clients" :clearable="false"
                  placeholder="Choisissez votre client..." @option:selected="onChangeClient($event)"
                  @option:clear="eraseInvoice()" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12" class="mb-0">
              <div>
                <b-row>
                  <b-col v-if="optionsEmail != '' || $invoice.client.contact" cols="12" md="12" class="mb-0 p-3">
                    <h5 class="mb-2">Contact</h5>
                  
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="Contact" label-for="contact">
                          <b-form-select v-model="selectedContact" :options="optionsEmail" @change="onChangeselectedContact()" />
                        </b-form-group>
                        <!-- INFORMATIONS CONTACT -->
                        <b-form-group label="Nom" label-for="contactnom">
                          <b-form-input id="contactnom" v-model="$invoice.client.contact.nom" placeholder="Nom" />
                        </b-form-group>
                        <b-form-group label="Prénom" label-for="contactprenom">
                          <b-form-input id="contactprenom" v-model="$invoice.client.contact.prenom" placeholder="Prénom" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="6">
                        <b-form-group label="Téléphone" label-for="contacttelephone">
                          <b-form-input id="contacttelephone" v-model="$invoice.client.contact.telephone" placeholder="Téléphone" />
                        </b-form-group>
                        <b-form-group label="Portable" label-for="contactportable">
                          <b-form-input id="contactportable" v-model="$invoice.client.contact.portable" placeholder="Portable" />
                        </b-form-group>
                        <b-form-group label="Email" label-for="contactemail">
                          <b-form-input id="contactemail" v-model="$invoice.client.contact.email" placeholder="Email" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col v-if="optionsEmail != '' || $invoice.client.contact" cols="12" md="6" class="mb-0 p-3"></b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12" class="mb-0">
              <div>

                <b-row>
                  <b-col v-if="optionsFacturation != '' || $invoice.client.adresseFacturation" cols="12" md="6"
                    class="mb-0 p-3">
                    <h5 class="mb-2">Adresse de facturation</h5>
                    <b-form-select v-model="selectedFacturation" :options="optionsFacturation"
                      @change="onChangeselectedFacturation()" class="mb-1" />
                    <div>
                      <b-form-group label="Adresse 1" label-for="adresse1fac">
                        <validation-provider #default="{ errors }" name="adrfacstate" rules="required">
                          <b-form-input id="adresse1fac" v-model="$invoice.client.adresseFacturation.adresse1"
                            :state="errors.length > 0 ? false : null" placeholder="Adresse 1" required />
                        </validation-provider>
                      </b-form-group>
                      <b-form-group label="Adresse 2" label-for="adresse2fac"><b-form-input id="adresse2fac"
                          v-model="$invoice.client.adresseFacturation.adresse2" placeholder="Adresse 2" />
                      </b-form-group>
                      <b-form-group label="Adresse 3" label-for="adresse3fac"><b-form-input id="adresse3fac"
                          v-model="$invoice.client.adresseFacturation.adresse3" placeholder="Adresse 3" />
                      </b-form-group>
                      <b-form-group label="Code postal" label-for="codepostalfac">
                        <validation-provider #default="{ errors }" name="cpfactate" rules="required">
                          <b-form-input id="codepostalfac" v-model="$invoice.client.adresseFacturation.codepostal"
                            :state="errors.length > 0 ? false : null" placeholder="Code postal" required />
                        </validation-provider>
                      </b-form-group>
                      <b-form-group label="Ville" label-for="villefac">
                        <validation-provider #default="{ errors }" name="villefacstate" rules="required">
                          <b-form-input id="villefac" v-model="$invoice.client.adresseFacturation.ville"
                            :state="errors.length > 0 ? false : null" placeholder="Ville" required />
                        </validation-provider>
                      </b-form-group>
                      <b-form-group label="Département" label-for="departementfac"><b-form-input id="departementfac"
                          v-model="$invoice.client.adresseFacturation.departement" placeholder="Département" />
                      </b-form-group>
                      <b-form-group label="Pays" label-for="paysfac"><b-form-input id="paysfac"
                          v-model="$invoice.client.adresseFacturation.pays" placeholder="Pays" /> </b-form-group>
                    </div>
                  </b-col>
                  <b-col v-if="optionsLivraison != '' || $invoice.client.adresseLivraison" cols="12" md="6"
                    class="mb-0 p-3">
                    <h5 class="mb-2">Adresse de livraison</h5>
                    <b-form-select v-model="selectedLivraison" :options="optionsLivraison"
                      @change="onChangeselectedLivraison()" class="mb-1" />
                    <div>
                      <b-form-group label="Adresse 1" label-for="adresse1liv">
                        <validation-provider #default="{ errors }" name="adrlivstate" rules="required">
                          <b-form-input id="adresse1liv" ref="adresse1liv"
                            v-model="$invoice.client.adresseLivraison.adresse1"
                            :state="errors.length > 0 ? false : null" placeholder="Adresse 1" />
                        </validation-provider>
                      </b-form-group>
                      <b-form-group label="Adresse 2" label-for="adresse2liv"><b-form-input id="adresse2liv"
                          v-model="$invoice.client.adresseLivraison.adresse2" placeholder="Adresse 2" /> </b-form-group>
                      <b-form-group label="Adresse 3" label-for="adresse3liv"><b-form-input id="adresse3liv"
                          v-model="$invoice.client.adresseLivraison.adresse3" placeholder="Adresse 3" /> </b-form-group>
                      <b-form-group label="Code postal" label-for="codepostalliv">
                        <validation-provider #default="{ errors }" name="cplivstate" rules="required">
                          <b-form-input id="codepostalliv" ref="codepostalliv"
                            v-model="$invoice.client.adresseLivraison.codepostal"
                            :state="errors.length > 0 ? false : null" placeholder="Code postal" required />
                        </validation-provider>
                      </b-form-group>
                      <b-form-group label="Ville" label-for="villeliv">
                        <validation-provider #default="{ errors }" name="villelivstate" rules="required">
                          <b-form-input id="villeliv" ref="villeliv" v-model="$invoice.client.adresseLivraison.ville"
                            placeholder="Ville" :state="errors.length > 0 ? false : null" />
                        </validation-provider>
                      </b-form-group>
                      <b-form-group label="Département" label-for="departementliv"><b-form-input id="departementliv"
                          v-model="$invoice.client.adresseLivraison.departement" placeholder="Département" />
                      </b-form-group>
                      <b-form-group label="Pays" label-for="paysliv"><b-form-input id="paysliv"
                          v-model="$invoice.client.adresseLivraison.pays" placeholder="Pays" /> </b-form-group>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col v-if="optionsLivraison != '' || $invoice.client.adresseLivraison" cols="12" md="12"
                    class="mb-0 pl-3 pr-3">
                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" @click="eraseInvoice()">
                      <feather-icon icon="Trash2Icon" class="mr-50" />
                      <span class="align-middle">Effacer la commande en cours</span>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- Choix des produits -->
      <tab-content title="Choix des produits" :before-change="validationProduct">
        <div class="invoice-add">
          <!-- Items Section -->
          <b-card-body class="invoice-padding form-item-section">
            <div ref="form" class="repeater-form was-validated">
              <b-row v-for="(item, index) in $invoice.products" :id="item.id" :key="item.id" ref="row" class="pb-2">

                <!-- Item Form -->
                <!-- ? This will be in loop => So consider below markup for single item -->
                <b-col cols="12">
                  <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                  <div class="d-none d-lg-flex">
                    <b-row class="flex-grow-1 px-1">
                      <!-- Single Item Form Headers -->
                      <b-col cols="12" xl="5" lg="4">
                        Produit
                      </b-col>
                      <b-col cols="12" lg="2">
                        Prix de la paire
                      </b-col>
                      <b-col cols="12" xl="3" lg="4" v-if="!item.variants">
                        Quantité de paire
                      </b-col>
                      <b-col cols="12" xl="3" lg="4" v-else>
                        Quantité d'assortiment
                      </b-col>
                      <b-col cols="12" lg="2">
                        Total
                      </b-col>
                    </b-row>
                    <div class="form-item-action-col" />
                  </div>
                  <!-- Form Input Fields OR content inside bordered area  -->
                  <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                  <div class="d-flex border rounded">
                    <b-row class="flex-grow-1 p-2">
                      <!-- Article -->
                      <b-col cols="12" xl="5" lg="4">
                        <b-row>
                          <!-- Image -->
                          <b-col cols="12" lg="1" class="m-lg-0 p-lg-0">
                            <a :href=item.image :data-lightbox="item.codearticle" :data-title=item.codearticle>
                              <img :src="item.image" height="38px" width="auto"
                                style="border: 1px solid #d8d6de; border-radius: 5px; max-width: auto; max-height: 38px;" />
                              <!-- <img :src="`blob:`+origine+`/`+item.image" height="42" width="auto" style="border: 1px solid #d8d6de; border-radius: 5px;"/> -->
                            </a>
                          </b-col>

                          <!-- Col article avec variante -->
                          <!-- Référence -->
                          <b-col cols="12" xl="6" lg="11" v-if="item.variants">
                            <label class="d-inline d-lg-none">Produit</label>
                            <v-select v-model="item.codearticle" :options="itemsOptions" label="codearticle"
                              :clearable="false" class="mb-2 item-selector-title"
                              placeholder="Choisissez une référence produit"
                              @input="val => updateItemForm(index, val)"/>
                          </b-col>
                          <!-- Col article sans variante -->
                          <b-col cols="12" lg="11" v-else>
                            <label class="d-inline d-lg-none">Produit</label>
                            <v-select v-model="item.codearticle" :options="itemsOptions" label="codearticle"
                              :clearable="false" class="mb-2 item-selector-title"
                              placeholder="Choisissez une référence produit"
                              @input="val => updateItemForm(index, val)"/>
                          </b-col>

                          <!-- Variantes -->
                          <b-col cols="12" xl="5" lg="12" v-if="item.variants">
                            <label class="d-inline d-lg-none">Variant</label>
                            <b-form-select v-model="item.variant" class="custom-select" required @change="onChangeselectedVariant($event, item, index)">
                              <template #first>
                                <b-form-select-option :value="null" disabled>-- CHOISISSEZ UN ASSORTEMENT --</b-form-select-option>
                              </template>
                              <b-form-select-option v-for=" (sousitem, sousindex) in item.variants" 
                                v-bind:value="sousitem.codearticle" :key="sousindex">
                                {{ sousitem.libelle }}
                              </b-form-select-option>
                            </b-form-select>
                            <div style="color:red;font-size:9px;padding-left:5px;" class="invalid-feedback">Choix de l'assortissement requis</div>
                          </b-col>

                          <!-- Nom -->
                          <b-col cols="0" v-else></b-col>
                          <b-col cols="12" lg="12" class="pl-lg-0 ml-lg-0">
                            <label class="d-inline d-lg-none">Nom</label>
                            <b-form-textarea v-model="item.nom" class="mb-2 mb-lg-0" required/>
                          </b-col>
                        </b-row>
                      </b-col>
                      <!-- Prix -->
                      <b-col cols="12" lg="2">
                        <label class="d-inline d-lg-none">Prix {{ setting.typedeprix }} </label>
                        <b-form-input v-if="!hasGammesPrix(item)" v-model="item.prix" type="number" step="any" min="0" class="mb-2" required/>
                        <div v-else class="mb-2" style="font-size: 80%;">
                          <div v-for="(g, idx) in groupedGammesTarifs(item)" :key="`${idx}-${g.prix}`">
                            {{ g.labels.join(' ') }} : <strong>{{ formatMoney(g.prix) }} {{ setting.devise }}</strong>
                          </div>
                        </div>
                        <p style="font-size: 80%;" v-if="item.variants">Prix de l'assortiment : {{ item.prixpack }} {{ setting.devise }} HT</p>
                      </b-col>
                      <!-- Quantité -->
                      <b-col cols="12" xl="3" lg="4">
                        <label class="d-inline d-lg-none">Quantité</label>
                        <b-form inline v-if="item.gammes">
                          <b-form-group :label="gamme.libelle + ' : '" label-for="input-sm" style="margin-bottom: 5px;"
                            v-for="(gamme, gammeindex) in item.gammes" :key="gammeindex">
                            <b-form-input size="sm" :name="gamme.libelle" :placeholder="gamme.libelle"
                              v-model="gamme.value" type="number" min="0" required
                              style="width: 60px; margin-left: 5px; margin-right: 5px;"
                              @keyup="onchangeQuantite(item, index)" onclick="this.select()" />
                          </b-form-group>
                        </b-form>
                        <b-form-input v-if="!item.gammes && !item.variants" v-model="item.quantite"
                          onclick="this.select()" type="number" min="0" required class="mb-2" />
                        <b-form-input v-if="item.variants" v-model="item.quantitepack" onclick="this.select()"
                          type="number" min="0" required class="mb-2" @keyup="onchangequantitepacks(item, index)" />
                        <b-form inline>
                          <b-form-group label="Paires totales : " label-for="input-sm" style="margin-bottom: 5px;"
                            v-if="item.gammes || item.variants">
                            <b-form-input v-model="item.quantite" size="sm" readonly type="number" min="0" required
                              :class="{ 
                                'input-valid-conditionnement': isValidConditionnement(item.quantite, item.conditionnement),
                                'input-invalid-conditionnement': item.conditionnement && item.quantite > 0 && !isValidConditionnement(item.quantite, item.conditionnement)
                              }"
                              style="width: 60px; margin-left: 5px; margin-right: 5px;" />
                          </b-form-group>
                        </b-form>
                        <p style="font-size: 80%;" v-if="item.conditionnement">Conditionnement : {{ item.conditionnement }}</p>

                      </b-col>
                      <!-- Total -->
                      <b-col cols="12" lg="2">
                        <label class="d-inline d-lg-none">Total</label>
                        <p class="mb-1">
                          <span v-if="item.remise != 0"><s>{{ formatMoney(itemTotalHTBase(item)) }} {{ setting.devise }} HT</s><br /></span>
                          <span>{{ formatMoney(itemTotalHT(item)) }} {{ setting.devise }} HT<br /></span>
                          <span v-if="$invoice.client.eligibleTVA == 1" style="font-size: 0.8em;">{{ formatMoney(itemTotalTTC(item)) }} {{ setting.devise }} TTC</span>
                          <span v-else style="font-size: 0.8em;">{{ formatMoney(itemTotalHT(item)) }} {{ setting.devise }} TTC </span>
                        </p>
                        <span v-if="item.remise != 0 || item.remise != '0'">
                          <p class="mb-0 mt-0" style="font-size: 80%;">
                            Remise : {{ item.remise }}% <br />
                            <!-- Montant de la remise : {{ item.montantremise = parseFloat((item.prix * (item.remise / 100)) * item.quantite).toFixed(2) }} {{ setting.devise }} HT -->
                          </p>
                        </span>
                      </b-col>
                    </b-row>
                    <!-- Setting -->
                    <div class="d-flex flex-column justify-content-between border-left py-50 px-25">
                      <feather-icon size="16" icon="XIcon" class="cursor-pointer" @click="removeItem(index)" />
                      <feather-icon :id="`form-item-settings-icon-${index}`" size="16" icon="SettingsIcon"
                        class="cursor-pointer" />

                      <!-- Setting Item Form -->
                      <b-popover :ref="`form-item-settings-popover-${index}`"
                        :target="`form-item-settings-icon-${index}`" triggers="click" placement="lefttop">
                        <b-form @submit.prevent>
                          <b-row>

                            <!-- Field: Discount -->
                            <b-col cols="12">
                              <b-form-group label="Remise(%)" :label-for="`setting-item-${index}-discount`">
                                <b-form-input :id="`setting-item-${index}-discount`" v-model="item.remise" :value="null"
                                  type="number" onclick="this.select()" />
                              </b-form-group>
                            </b-col>

                            <!-- Field: Tax 1 -->
                            <b-col cols="6">
                              <b-form-group label="TVA" :label-for="`setting-item-${index}-tax-1`">
                                <b-form-input v-model="item.tva" readonly type="number" class="mb-2" />
                              </b-form-group>
                            </b-col>

                            <b-col cols="12" class="d-flex justify-content-between mt-1">
                              <b-button variant="outline-primary"
                                @click="() => { $refs[`form-item-settings-popover-${index}`][0].$emit('close') }">
                                Appliquer
                              </b-button>
                              <b-button variant="outline-secondary"
                                @click="() => { $refs[`form-item-settings-popover-${index}`][0].$emit('close') }">
                                Annuler
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-popover>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="addNewItemInItemForm">
              Ajouter un produit
            </b-button>
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success" class="btn-icon"
              v-b-modal.modalarticle>
              <feather-icon icon="SearchIcon" class="mr-50" />
              <span class="align-middle">Recherche d'article</span>
            </b-button>
            <!-- Modal recherche produit-->
            <b-modal ref="modalarticle" id="modalarticle" title="Recherche d'article" size="xl" ok-only
              ok-title="Accept">
              <!-- Table Top -->
              <b-row>
                <!-- Per Page -->
                <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                  <label>Afficher</label>
                  <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="pageOptions"
                    :clearable="false" class="per-page-selector d-inline-block mx-50" />
                  <label>entrées</label>

                </b-col>

                <!-- Search -->
                <b-col cols="12" md="6">
                  <div class="d-flex align-items-center justify-content-end">

                  </div>
                </b-col>
                <!-- Select Sous catégories -->
                <b-col cols="12" md="4" class="mt-2 pr-4">
                  <b-form-group label="Collection :" label-for="vi-collection">
                    <v-select v-model="selectedCategoriesArticle" placeholder="Choisissez une collection"
                      :options="categoriesarticles" @option:selected="onChangeCategoryArticles($event)"
                      style="text-transform: capitalize;" />
                  </b-form-group>
                </b-col>
                <!-- Select Sous catégories -->
                <b-col cols="12" md="4" class="mt-2 pr-4">
                  <b-form-group label="Marque :" label-for="vi-marque">
                    <v-select v-model="selectedFournisseur" placeholder="Choisissez une marque" :options="fournisseurs"
                      @option:selected="onChangeFournisseurs($event)" style="text-transform: capitalize;" />
                  </b-form-group>
                </b-col>

                <!-- Filter On -->
                <b-col cols="12" md="4" class="mt-3">
                  <b-input-group size="sm">
                    <b-form-input id="filterInput" v-model="filterInput" type="search"
                      placeholder="Saisissez votre recherche" @keyup="applyFilter" />
                    <b-input-group-append>
                      <b-button @click="applyFilterEnter">
                        Rechercher
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-group v-slot="{ ariaDescribedby }" v-model="sortDirection"
                    description="Laissez tout décoché pour filtrer sur toutes les données" class="mt-0">
                    <b-form-checkbox-group v-model="filterOn" :aria-describedby="ariaDescribedby" class="mt-1 mb-0">
                      <b-form-checkbox class="mb-1" value="codearticle">
                        Code article
                      </b-form-checkbox>
                      <b-form-checkbox class="mb-1" value="nom">
                        Nom
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Tableau -->
              <b-row>
                <b-col cols="12">
                  <b-card-text>
                    <b-table id="datatables" class="mt-4 mb-4" :items="products" :fields="fields" stacked="md"
                      :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" striped small
                      @filtered="onFiltered" @row-clicked="selectedCol">
                      <!-- IMAGES -->
                      <template #cell(image)="data">
                        <a :href=data.value :data-lightbox="data.item.id" :data-title=data.item.nom>
                          <img :src=data.value height="60" width="auto" />
                        </a>
                      </template>

                      <!-- PRIX -->
                      <template #cell(prix)="data">
                        <span>{{ parseFloat(data.value).toFixed(2) }} {{ setting.devise }} HT </span><br />
                        <span v-if="$invoice.client.eligibleTVA == 1" style="font-size: 0.8em;">{{ parseFloat( data.value + (data.value * (data.item.tva / 100))).toFixed(2) }} {{ setting.devise }} TTC</span>
                        <span v-else style="font-size: 0.8em;">{{ parseFloat(data.value).toFixed(2) }} {{ setting.devise }} TTC</span>
                      </template>

                      <!-- FAMILLES -->
                      <template #cell(categoriesarticles)="data">
                        <span v-for="(famille, familleindex) in data.item.categoriesarticles" :key="familleindex">
                          <span v-if="familleindex != data.item.categoriesarticles.length - 1">,</span>
                        </span>
                      </template>

                      <!-- Column: Actions -->
                      <template #cell(actions)="data">
                        <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-success"
                          class="btn-icon rounded-circle">
                          <feather-icon icon="PlusCircleIcon" />
                        </b-button>
                      </template>
                    </b-table>
                  </b-card-text>
                </b-col>
              </b-row>
            </b-modal>
          </b-card-body>

          <!-- Invoice Description: Total -->
          <b-card-body class="invoice-padding pb-0">
            <b-row>

              <!-- Col: Sales Persion -->
              <b-col cols="12" md="6" class="mt-md-0 mt-3 d-flex align-items-center" order="2" order-md="1">
              </b-col>

              <!-- Col: Total -->
              <b-col cols="12" md="6" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                <div class="invoice-total-wrapper">
                  <div class="invoice-total-item mb-2" style="font-size: 80%">
                    <p class="invoice-total-title">
                      Total paires :
                    </p>
                    <p class="invoice-total-amount">
                      {{ totalPaire }}
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Sous-total HT :
                    </p>
                    <p class="invoice-total-amount">
                      {{ totalMontant }} {{ setting.devise }}
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Remise :
                    </p>
                    <p class="invoice-total-amount">
                      <b-form-input id="remisepanier" size="sm" v-model="$invoice.remisepanier" onclick="this.select()"
                        placeholder="0" type="number" style="width: 50px; display: inline-block; text-align: right;" />
                      %
                    </p>
                  </div>
                  <div class="invoice-total-item" v-if="this.commercial.showfraisport == 'true'">
                    <p class="invoice-total-title">
                      Estimation frais de port HT :
                    </p>
                    <p class="invoice-total-amount">
                      {{ totalFraisPortHT }} {{ setting.devise }}
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      TVA :
                    </p>
                    <p class="invoice-total-amount">
                      {{ totalMontantTva }} {{ setting.devise }}
                    </p>
                  </div>
                  <hr class="my-50">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Total TTC :
                    </p>
                    <p class="invoice-total-amount">
                      {{ totalMontantTTC }} {{ setting.devise }}
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </div>
      </tab-content>

      <!-- Validation de commande -->
      <tab-content title="Validation de commande">
        <b-row class="invoice-add">

          <b-col cols="12" xl="12" md="12">
            <b-form @submit.prevent>
              <b-card no-body class="invoice-preview-card">
                <!-- Header -->
                <b-card-body class="invoice-padding pb-0">

                  <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">

                    <!-- Header: Left Content -->
                    <div>
                      <h3 class="text-primary">
                        {{ setting.societe }}
                      </h3>
                      <b-card-text class="mb-25">
                        {{ setting.adresse1 }}
                      </b-card-text>
                      <b-card-text class="mb-25" v-if="setting.adresse2">
                        {{ setting.adresse2 }}
                      </b-card-text>
                      <b-card-text class="mb-25" v-if="setting.adresse3">
                        {{ setting.adresse3 }}
                      </b-card-text>
                      <b-card-text class="mb-0">
                        {{ setting.codepostal }} {{ setting.ville }}
                      </b-card-text>
                      <b-card-text class="mb-0">
                        {{ setting.pays }}
                      </b-card-text>
                    </div>

                    <!-- Header: Right Content -->
                    <div class="invoice-number-date mt-md-0 mt-2">
                      <div class="d-flex align-items-center mb-0">
                        <b-form-group label="Date de commande :" label-for="datecommande">
                          <flat-pickr v-model="$invoice.datecommande" :config="config"
                            class="form-control invoice-edit-input" />
                        </b-form-group>
                      </div>
                      <div class="d-flex align-items-center mb-0">
                        <b-form-group label="Mode de paiement :" label-for="modepaiement" v-if="$invoice.client.nom">
                          <!-- <b-form-input v-model="$invoice.client.modepaiement" readonly v-if="$invoice.client.modepaiement"/>
                          <b-form-input v-model="$invoice.client.modepaiement" v-else/> -->
                          <v-select v-if="$invoice.client.nom.includes('DIVERS')" v-model="selectedModepaiement"
                            placeholder="Mode de paiement" :options="modespaiement"
                            @option:selected="onChangeModepaiement($event)"
                            style="text-transform: capitalize; min-width: 340px;" />
                          <v-select v-else v-model="selectedModepaiement" placeholder="Mode de paiement"
                            :options="modespaiement" @option:selected="onChangeModepaiement($event)"
                            style="text-transform: capitalize; min-width: 340px;" disabled />
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </b-card-body>

                <!-- Spacer -->
                <hr class="invoice-spacing">

                <!-- Commercial -->
                <b-card-body class="invoice-padding pt-0">
                  <h3>Commercial</h3>
                  <span class="font-weight-bold">Choix d'un commercial : </span>
                  <v-select v-if="role.includes('manager' + this.database)" v-model="selectedCommerciaux"
                    placeholder="Commercial" :options="commerciaux" @option:selected="onChangeCommerciaux($event)"
                    style="text-transform: capitalize; min-width: 340px;" />
                </b-card-body>
                <b-row>
                  <b-col cols="12" md="4" class="mb-2">
                    <b-card-body class="invoice-padding pt-0">
                      <span class="font-weight-bold">Nom : </span>
                      <b-form-input v-model="$invoice.nomcommercial" />
                    </b-card-body>
                  </b-col>
                  <b-col cols="12" md="4" class="mb-2">
                    <b-card-body class="invoice-padding pt-0">
                      <span class="font-weight-bold">Email : </span>
                      <b-form-input v-model="$invoice.commercial" />
                    </b-card-body>
                  </b-col>

                  <b-col cols="12" md="4" class="mb-2">
                    <b-card-body class="invoice-padding pt-0">
                      <span class="font-weight-bold">Téléphone : </span>
                      <b-form-input v-model="$invoice.telcommercial" />
                    </b-card-body>
                  </b-col>
                </b-row>
                <!-- Spacer -->
                <hr class="invoice-spacing">

                <!-- Note -->
                <b-card-body class="invoice-padding pt-0">
                  <span class="font-weight-bold">Note : </span>
                  <b-form-textarea v-model="$invoice.note" />
                </b-card-body>
                <!-- Spacer -->
                <hr class="invoice-spacing">

                <!-- Signature -->
                <b-card-body class="invoice-padding pt-0">
                  <span class="font-weight-bold">Signature : </span><br />
                  <VueSignaturePad width="480px" height="200px" ref="signaturePad"
                    :options="{ onBegin: () => { $refs.signaturePad.resizeCanvas() } }" class="signature" />
                  <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" size="sm" class="mt-1"
                    @click="clearSignature()">
                    <span class="align-middle">Effacer la signature</span>
                  </b-button>
                  <b-form-checkbox v-model="$invoice.consent" value="oui" class="custom-control-primary mt-2">
                    J'accepte les conditions générales de vente
                  </b-form-checkbox>
                </b-card-body>
              </b-card>
            </b-form>
          </b-col>

        </b-row>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BForm,
  BFormInput,
  BInputGroup,
  BFormSelect,
  BFormSelectOption,
  BInputGroupAppend,
  BButton,
  BTable,
  BLink,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BFormTextarea,
  BFormCheckboxGroup,
  BFormSpinbutton,
  BFormRadioGroup,
  BImg,
  BCardText,
  BFormRadio,
  BFormDatepicker,
  BPopover,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import Vue from 'vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { localize, ValidationProvider, ValidationObserver } from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr.json';
localize('fr', fr);

import { required } from '@validations'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'

import flatPickr from 'vue-flatpickr-component'
import { French } from 'flatpickr/dist/l10n/fr.js'
flatpickr.localize(French)

import { VueSignaturePad } from 'vue-signature-pad'

import "jquery/dist/jquery.min.js"
import "lightbox2/dist/css/lightbox.min.css"
import "lightbox2/dist/js/lightbox.min.js"

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormSelect,
    BFormSelectOption,
    BButton,
    BTable,
    BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BFormCheckboxGroup,
    BFormSpinbutton,
    BFormRadioGroup,
    BImg,
    BCardText,
    BFormRadio,
    TabContent,
    FormWizard,
    BFormDatepicker,
    BPopover,
    BModal,
    flatPickr,
    vSelect,
    VueSignaturePad,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  data() {
    return {
      localDB: new PouchDB(localStorage.getItem('database')),
      remoteDB: new PouchDB(localStorage.getItem('url') + '/' + localStorage.getItem('database')),
      fields: [
        { key: 'image', label: '', thStyle: { width: '160px' }, class: 'attachments' },
        { key: 'codearticle', label: 'Code article', sortable: true },
        { key: 'nom', label: 'Nom', sortable: true },
        { key: 'prix', label: 'Prix', sortable: true, class: 'text-center', thStyle: { width: '120px' } },
        { key: 'actions', label: '', thStyle: { width: '10px' } },
      ],
      required,
      products: [],
      /** Incrémenté à chaque nouvelle recherche articles (évite doublons si deux find() se chevauchent). */
      articleSearchGeneration: 0,
      setting: JSON.parse(localStorage.setting),
      commercial: JSON.parse(localStorage.commercial),
      clients: [],
      familles: [],
      souscategories: [],
      fournisseurs: [],
      modespaiement: [],
      commerciaux: [],
      listcommerciaux: [],
      categoriesarticles: [],
      clientSelect: [],
      selectedClient: [],
      selectedFamille: [],
      selectedCategoriesArticle: [],
      selectedSousCategories: [],
      selectedFournisseur: [],
      selectedModepaiement: [],
      selectedCommerciaux: [],
      selectedVariant: '',
      invoiceData: '',
      itemsOptions: [],
      itemsOptionsFind: [],
      listproducts: '',
      isLoading: true,
      drawer: true,
      perPage: 100,
      currentPage: 1,
      totalRows: 1,
      currentPage: 1,
      filterInput: '',
      datelivraison: '',
      commandeDate: moment().format('YYYY-MM-DD HH:mm'),
      pageOptions: [10, 25, 50, 100],
      filter: null,
      outlined: true,
      filterOn: [],
      sortBy: 'codearticle',
      sortDirection: 'asc',
      sortDesc: false,
      selectedLivraison: '',
      optionsLivraison: [],
      selectedFacturation: '',
      optionsFacturation: [],
      selectedContact: '',
      optionsEmail: [],
      adrLivraison: '',
      adrFacturation: '',
      config: {
        wrap: true,
        minDate: 'today',
        altFormat: 'd/m/Y',
        time_24hr: true,
        altInput: true,
        dateFormat: 'Y-m-d H:i'
      },
      itemFormBlankItem: {
        prix: 0,
        quantite: 0,
        nom: '',
        image: '',
        variant: '',
        gamme: '',
        tva: 0,
        remise: 0,
        conditionnement: '',
      },
      role: localStorage.getItem('role'),
      database: localStorage.getItem('database')
    }
  },
  computed: {
    rows() {
      return this.items.length
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    // Total montant HT
    totalMontant() {
      this.$invoice.totalmontant = 0
      if (this.$invoice.products) {
        this.$invoice.products.forEach(i => { this.$invoice.totalmontant += this.itemTotalHT(i) })
        // this.$invoice.totalmontant = (totalM).toFixed(2)
      }
      return parseFloat(this.$invoice.totalmontant).toFixed(2)
    },
    // Total frais de port HT
    totalFraisPortHT() {
      this.totalMontant
      this.totalPaire
      this.$invoice.totalfraisport = this.computeFraisPortHT()
      return parseFloat(this.$invoice.totalfraisport).toFixed(2)
    },
    // Total TVA
    totalMontantTva() {
      this.$invoice.totalmontanttva = 0
      if (this.$invoice.products) {
        if (this.$invoice.client.eligibleTVA == 1) {
          this.$invoice.products.forEach(i => {
            this.$invoice.totalmontanttva += (this.itemTotalHT(i) * (this.toNumber(i.tva) / 100))
          })
          if (!this.isFrancoPort()) {
            this.$invoice.totalmontanttva += this.toNumber(this.computeFraisPortHT()) * 0.2
          }
        }
      }
      return parseFloat(this.$invoice.totalmontanttva).toFixed(2)
    },  
    // Total montant TTC
    totalMontantTTC() {
      this.$invoice.totalmontantttc = 0
      if (this.$invoice.products) {
        const remise = this.toNumber(this.$invoice.remisepanier) / 100
        this.$invoice.products.forEach(i => {
          const ht = this.itemTotalHT(i)
          if (this.$invoice.client.eligibleTVA == 1) {
            this.$invoice.totalmontantttc += (ht * (1 - remise) * (1 + (this.toNumber(i.tva) / 100)))
          }
          else {
            this.$invoice.totalmontantttc += (ht * (1 - remise))
          }
        })
        if (!this.isFrancoPort()) {
          const fraisPort = this.toNumber(this.computeFraisPortHT())
          if (this.$invoice.client.eligibleTVA == 1) {
            this.$invoice.totalmontantttc += fraisPort * 1.2
          }
          else {
            this.$invoice.totalmontantttc += fraisPort
          }
        }
      }
      return parseFloat(this.$invoice.totalmontantttc).toFixed(2)
    },  
    // Total paires
    totalPaire() {
      this.$invoice.totalPaire = 0
      if (this.$invoice.products) {
        this.$invoice.products.forEach(i => { this.$invoice.totalPaire += parseInt(i.quantite) })
      }
      return this.$invoice.totalPaire
    }
  },
  customButtons: {
    default: true,
  },
  created() {
    this.$invoice.commercial = localStorage.getItem('user')
    this.$invoice.nomcommercial = JSON.parse(localStorage.getItem('commercial')).nom + ' ' + JSON.parse(localStorage.getItem('commercial')).prenom
    this.$invoice.telcommercial = JSON.parse(localStorage.getItem('commercial')).phone

    this.$invoice.datecommande = moment().format('YYYY-MM-DD H:mm')
    this.$invoice.totalmontant = 0
    this.$invoice.totalmontanttva = 0
    this.$invoice.totalmontantttc = 0

    this.initializeClients()
    this.initializeArticles()
    this.initializeCategoriesArticles()
    this.initializeFournisseurs()
    this.initializeModesPaiement()
    this.initializeCommerciaux()
  },
  methods: {
    toNumber(value) {
      const n = typeof value === 'string' && value.trim() !== '' ? Number(value) : Number(value)
      return Number.isFinite(n) ? n : 0
    },
    hasSettingValue(value) {
      return value !== '' && value !== null && value !== undefined
    },
    isFrancoPort() {
      if (this.commercial.showfraisport == 'false') return true
      if (this.hasSettingValue(this.setting.franco) && this.totalPaire > this.toNumber(this.setting.franco)) return true
      if (this.hasSettingValue(this.setting.francomontant) && this.toNumber(this.$invoice.totalmontant) > this.toNumber(this.setting.francomontant)) return true
      return false
    },
    computeFraisPortHT() {
      if (this.isFrancoPort()) return 0
      if (this.hasSettingValue(this.setting.fraisportmontant)) {
        return this.toNumber(this.setting.fraisportmontant)
      }
      if (this.hasSettingValue(this.setting.fraisport) && this.$invoice.products) {
        return this.$invoice.products.reduce(
          (sum, i) => sum + (this.toNumber(i.quantite) * this.toNumber(this.setting.fraisport)),
          0,
        )
      }
      return 0
    },
    formatMoney(value) {
      return this.toNumber(value).toFixed(2)
    },
    itemTotalHTBase(item) {
      if (!item) return 0

      const prixProduit = this.toNumber(item.prix)
      const quantite = this.toNumber(item.quantite)

      if (Array.isArray(item.gammes) && item.gammes.length > 0) {
        return item.gammes.reduce((sum, gamme) => {
          const q = this.toNumber(gamme?.value)
          if (!q) return sum

          const prixGamme = Object.prototype.hasOwnProperty.call(gamme, 'prix') ? this.toNumber(gamme?.prix) : null
          const unit = prixGamme !== null ? prixGamme : prixProduit
          return sum + (unit * q)
        }, 0)
      }

      return prixProduit * quantite
    },
    itemTotalHT(item) {
      const base = this.itemTotalHTBase(item)
      const remise = this.toNumber(item?.remise)
      return base * (1 - (remise / 100))
    },
    itemTotalTTC(item) {
      const ht = this.itemTotalHT(item)
      const tva = this.toNumber(item?.tva)
      return ht * (1 + (tva / 100))
    },
    hasGammesPrix(item) {
      return Array.isArray(item?.gammes) && item.gammes.some(g => Object.prototype.hasOwnProperty.call(g, 'prix'))
    },
    groupedGammesTarifs(item) {
      if (!Array.isArray(item?.gammes)) return []

      const groups = new Map()
      item.gammes.forEach(g => {
        const unit = Object.prototype.hasOwnProperty.call(g, 'prix') ? this.toNumber(g?.prix) : this.toNumber(item?.prix)
        const key = unit.toFixed(6)
        const labels = groups.get(key) || { prix: unit, labels: [] }
        labels.labels.push(String(g?.libelle ?? '').trim())
        groups.set(key, labels)
      })

      return Array.from(groups.values()).map(g => ({
        prix: g.prix,
        labels: g.labels.filter(Boolean),
      }))
    },
    //Initialize Clients
    async initializeClients() {
      //Récupération des clients
      if(this.setting.filtre_clients_par_commerciaux == false || this.setting.filtre_clients_par_commerciaux == 'false' || this.role.includes('admin'+localStorage.getItem('database')) || this.role.includes('manager'+localStorage.getItem('database'))) {
        await this.localDB.find({ selector: { type: 'clients' } }, this.setClients)
      }
      else {
        await this.localDB.find({ selector: { type: 'clients', commerciaux: { $elemMatch: { $eq: localStorage.getItem('user') } } } }, this.setClients)
      }
    },
    //Initialize Catégories d'articles
    async initializeCategoriesArticles() {
      //Récupération des catégories articles
      await this.localDB.find({ selector: { type: 'categoriesarticles' } }, (err, doc) => {
        if (err) {
          console.log('err', err)
        } else {
          // console.log('docCategoriesArticles', doc)
          for (let i = 0; i < doc.docs.length; i++) {
            if (this.setting.saison != '' && doc.docs[i].id == this.setting.saison) {
              this.categoriesarticles.push({
                label: doc.docs[i].nom,
                value: doc.docs[i].id,
              })
            }
            if (this.setting.saison == '') {
              this.categoriesarticles.push({
                label: doc.docs[i].nom,
                value: doc.docs[i].id,
              })
            }
          }
          console.log('collections', this.categoriesarticles)
        }
      })
    },
    //Initialize Fournisseurs
    async initializeFournisseurs() {
      //Récupération des fournisseurs
      await this.localDB.find({ selector: { type: 'fournisseurs' } }, (err, doc) => {
        if (err) {
          console.log('err', err)
        } else {
          // console.log('docFournisseurs', doc)
          for (let i = 0; i < doc.docs.length; i++) {
            this.fournisseurs.push({
              label: doc.docs[i].nom,
              value: doc.docs[i].id,
            })
          }
          console.log('fournisseurs', this.fournisseurs)
        }
      })
    },
    //Initialize Modes de paiement
    async initializeModesPaiement() {
      //Récupération des fournisseurs
      await this.localDB.find({ selector: { type: 'modespaiement' } }, (err, doc) => {
        if (err) {
          console.log('err', err)
        } else {
          // console.log('docFournisseurs', doc)
          for (let i = 0; i < doc.docs.length; i++) {
            this.modespaiement.push({
              label: doc.docs[i].nom,
              value: doc.docs[i].nom,
            })
          }
          console.log('modespaiement', this.modespaiement)
        }
      })
    },
    //Initialize Commerciaux
    async initializeCommerciaux() {
      //Récupération des fournisseurs
      await this.localDB.find({ selector: { type: 'commerciaux' } }, (err, doc) => {
        if (err) {
          console.log('err', err)
        } else {
          // console.log('docFournisseurs', doc)
          this.listcommerciaux = doc.docs
          for (let i = 0; i < doc.docs.length; i++) {
            this.commerciaux.push({
              label: doc.docs[i].email,
              value: doc.docs[i].email,
            })
          }
          console.log('commerciaux', this.listcommerciaux)
        }
      })
    },
    //Initialize Articles
    async initializeArticles() {
      //Récupération des articles
      const mySelector = {};
      mySelector.type = 'articles';

      if (this.setting.saison != '' && this.commercial.showallsaison != 'true') {
        mySelector.categorie = this.setting.saison;
      }

      if (this.setting.filtre_articles_par_commerciaux == true || this.setting.filtre_articles_par_commerciaux == 'true') {
        mySelector.commerciaux = { $elemMatch: { $eq: localStorage.getItem('user') } };
      }
      
      await this.localDB.find({ selector: mySelector }, this.setArticles)
    },
    // SET Clients
    async setClients(err, doc) {
      if (err) {
        console.log('err', err)
      } else {
        // console.log('docClients', doc)
        for (let i = 0; i < doc.docs.length; i++) {
          this.clients.push({
            label: doc.docs[i].idclient + ' - ' + doc.docs[i].nom,
            value: doc.docs[i]._id,
          })
        }
        // console.log('Clients', this.clients)
      }
      // console.log('invoiceselectedClient', this.$invoice)
      if (this.$invoice.client.idclient) {
        await this.selectedClient.push({
          label: this.$invoice.client.idclient + ' - ' + this.$invoice.client.nom,
          value: this.$invoice.client._id,
        })
        this.clientSelect = this.$invoice.client
        this.onClientSelected(this.$invoice.client._id)
        console.log('clientSelect', this.clientSelect)
      }

    },
    // SET Articles
    async setArticles(err, doc) {
      if (err) {
        console.log('err', err)
      } else {
        console.log('docArticles', doc)
        this.itemsOptions = []

        for (let i = 0; i < doc.docs.length; i++) {

          let image = require('@/assets/images/emptyimg.png')

          if (!doc.docs[i]._attachments) {
            // console.log('no attachement')
            image = require('@/assets/images/emptyimg.png')
          } else {
            // console.log('attached', Object.keys(doc.docs[i]._attachments)[0])
            // await this.localDB.getAttachment(doc.docs[i]._id, Object.keys(doc.docs[i]._attachments)[0]).then((blobOrBuffer) => {
            await this.localDB.getAttachment(doc.docs[i]._id, Object.keys(doc.docs[i]._attachments)[0]).then(
              (blobOrBuffer) => {
                // console.log('url', URL.createObjectURL(blobOrBuffer))
                image = URL.createObjectURL(blobOrBuffer)
              },
              (error) => {
                // console.log(error)
                image = require('@/assets/images/emptyimg.png')
              }
            );
          }
          await this.itemsOptions.push({
            id: doc.docs[i]._id,
            codearticle: doc.docs[i].codearticle,
            nom: doc.docs[i].nom,
            conditionnement: doc.docs[i].conditionnement,
            variants: doc.docs[i].variants,
            gammes: doc.docs[i].gammes,
            image: image,
            prix: doc.docs[i].prix,
            fournisseur: doc.docs[i].fournisseur,
            quantite: 0,
            tva: doc.docs[i].tva,
            montanttva: doc.docs[i].prix * (doc.docs[i].tva / 100),
            remise: 0,
            montantremise: 0,
          })
          // console.log("products", this.itemsOptions)
        }
        console.log("products", this.itemsOptions)
        // this.totalRows = this.products.length
      }
    },
    async setSearchArticles(err, doc, gen) {
      if (gen !== undefined && gen !== this.articleSearchGeneration) return
      if (err) {
        console.log('err', err)
      } else {
        console.log('docSearchArticles', doc)
        this.products = []
        for (let i = 0; i < doc.docs.length; i++) {
          if (gen !== undefined && gen !== this.articleSearchGeneration) return

          if (!doc.docs[i]._attachments) {
            // console.log('no attachement')
            this.image = require('@/assets/images/emptyimg.png')
          } else {
            // console.log('attached', Object.keys(doc.docs[i]._attachments)[0])
            await this.localDB.getAttachment(doc.docs[i]._id, Object.keys(doc.docs[i]._attachments)[0]).then(
              (blobOrBuffer) => {
                // console.log('url', URL.createObjectURL(blobOrBuffer))
                this.image = URL.createObjectURL(blobOrBuffer)
              },
              (error) => {
                // console.log(error)
                this.image = require('@/assets/images/emptyimg.png')
              }
            );
          }

          if (gen !== undefined && gen !== this.articleSearchGeneration) return

          this.products.push({
            id: doc.docs[i]._id,
            codearticle: doc.docs[i].codearticle,
            nom: doc.docs[i].nom,
            libelle: doc.docs[i].nom,
            variants: doc.docs[i].variants,
            conditionnement: doc.docs[i].conditionnement,
            gammes: doc.docs[i].gammes,
            image: this.image,
            prix: doc.docs[i].prix,
            fournisseur: doc.docs[i].fournisseur,
            quantite: 0,
            tva: doc.docs[i].tva,
          })
        }
        // console.log("product", this.products)
        if (gen === undefined || gen === this.articleSearchGeneration) {
          this.totalRows = this.products.length
        }
      }
    },
    // Choix d'un client
    async onChangeClient(events) {
      console.log('events', events);
      await this.localDB.get(events.value).then(doc => {

        this.$invoice.client._id = doc._id
        this.$invoice.client.idclient = doc.idclient
        this.$invoice.client.nom = doc.nom
        if (doc.modepaiement != null) {
          this.$invoice.client.modepaiement = doc.modepaiement[0].libelle
        }
        else { this.$invoice.client.modepaiement = '' }

        this.$invoice.client.eligibleTVA = doc.eligibleTVA

        this.clientSelect = doc
        console.log('clientSelect', doc)

        this.optionsEmail = []
        this.optionsEmail.push({ value: -1, text: 'Nouveau contact' })
        if (doc.contacts != null) {
          for (let i = 0; i < doc.contacts.length; i++) {
            if (doc.contacts[i].email != null) {
              this.optionsEmail.push({
                value: i,
                text: doc.contacts[i].nom + ' ' + doc.contacts[i].prenom,
              })
              if (i === 0) {
                this.selectedContact = i
                this.onChangeselectedContact()
              }
            }
          }
        }

        this.optionsLivraison = []
        this.optionsLivraison.push({
          value: '',
          text: '',
        })

        this.optionsFacturation = []
        this.optionsFacturation.push({
          value: '',
          text: '',
        })

        for (let i = 0; i < doc.adresses.length; i++) {
          if (doc.adresses[i].type == 'LIVR' && doc.adresses[i].defaut == 'true') {
            this.optionsLivraison.push({
              value: i,
              text: doc.adresses[i].adresse1 + ' ' + doc.adresses[i].codepostal + ' ' + doc.adresses[i].ville + ' (défaut)',
            })
            this.selectedLivraison = i;
            this.onChangeselectedLivraison()
          }
          else if (doc.adresses[i].type == 'LIVR') {
            this.optionsLivraison.push({
              value: i,
              text: doc.adresses[i].adresse1 + ' ' + doc.adresses[i].codepostal + ' ' + doc.adresses[i].ville,
            })
          }

          if (doc.adresses[i].type == 'FACT' && doc.adresses[i].defaut == 'true') {
            this.optionsFacturation.push({
              value: i,
              text: doc.adresses[i].adresse1 + ' ' + doc.adresses[i].codepostal + ' ' + doc.adresses[i].ville + ' (défaut)',
            })
            this.selectedFacturation = i;
            this.onChangeselectedFacturation()
          }
          else if (doc.adresses[i].type == 'FACT') {
            this.optionsFacturation.push({
              value: i,
              text: doc.adresses[i].adresse1 + ' ' + doc.adresses[i].codepostal + ' ' + doc.adresses[i].ville,
            })
          }
        }

        this.selectedModepaiement = []
        if (this.$invoice.client.modepaiement) {
          this.selectedModepaiement.push({
            label: this.$invoice.client.modepaiement,
            value: this.$invoice.client.modepaiement,
          })
        }

      }).catch(function (err) {
        console.log('err', err);
      });
    },
    async onClientSelected(client) {
      await this.localDB.get(client).then(doc => {

        this.clientSelect = doc
        console.log('clientSelect', doc)

        this.optionsEmail = []
        this.optionsEmail.push({ value: -1, text: 'Nouveau contact' })
        let contactFound = false
        if (doc.contacts != null) {
          for (let i = 0; i < doc.contacts.length; i++) {
            if (doc.contacts[i].email != null) {
              this.optionsEmail.push({
                value: i,
                text: doc.contacts[i].nom + ' ' + doc.contacts[i].prenom,
              })
              // Si un contact existe déjà dans la commande, on affiche la sélection sans écraser (données modifiables)
              if (this.$invoice.client.contact && this.$invoice.client.contact.email === doc.contacts[i].email) {
                this.selectedContact = i
                contactFound = true
              }
            }
          }
          // Si aucun contact n'a été trouvé, on initialise le premier
          if (!contactFound && this.optionsEmail.length > 0) {
            this.selectedContact = 0
            this.onChangeselectedContact()
          }
        }

        this.optionsLivraison = []
        this.optionsLivraison.push({
          value: '',
          text: '',
        })

        this.optionsFacturation = []
        this.optionsFacturation.push({
          value: '',
          text: '',
        })

        for (let i = 0; i < doc.adresses.length; i++) {
          if (doc.adresses[i].type == 'LIVR' && doc.adresses[i].defaut == 'true') {
            this.optionsLivraison.push({
              value: i,
              text: doc.adresses[i].adresse1 + ' ' + doc.adresses[i].codepostal + ' ' + doc.adresses[i].ville + ' (défaut)',
            })
            // this.selectedLivraison = i;
            // this.onChangeselectedLivraison()
          }
          else if (doc.adresses[i].type == 'LIVR') {
            this.optionsLivraison.push({
              value: i,
              text: doc.adresses[i].adresse1 + ' ' + doc.adresses[i].codepostal + ' ' + doc.adresses[i].ville,
            })
          }

          if (doc.adresses[i].type == 'FACT' && doc.adresses[i].defaut == 'true') {
            this.optionsFacturation.push({
              value: i,
              text: doc.adresses[i].adresse1 + ' ' + doc.adresses[i].codepostal + ' ' + doc.adresses[i].ville + ' (défaut)',
            })
            // this.selectedFacturation = i;
            // this.onChangeselectedFacturation()
          }
          else if (doc.adresses[i].type == 'FACT') {
            this.optionsFacturation.push({
              value: i,
              text: doc.adresses[i].adresse1 + ' ' + doc.adresses[i].codepostal + ' ' + doc.adresses[i].ville,
            })
          }
        }

      }).catch(function (err) {
        console.log('err', err);
      });
    },
    // Choix de l'adresse de livraison
    onChangeselectedLivraison() {
      this.$invoice.client.adresseLivraison = ''
      console.log(this.clientSelect.adresses[this.selectedLivraison]);
      this.$invoice.client.adresseLivraison = {
        adresse1: this.clientSelect.adresses[this.selectedLivraison].adresse1,
        adresse2: this.clientSelect.adresses[this.selectedLivraison].adresse2,
        adresse3: this.clientSelect.adresses[this.selectedLivraison].adresse3,
        codepostal: this.clientSelect.adresses[this.selectedLivraison].codepostal,
        ville: this.clientSelect.adresses[this.selectedLivraison].ville,
        departement: this.clientSelect.adresses[this.selectedLivraison].departement,
        pays: this.clientSelect.adresses[this.selectedLivraison].pays,
      }
    },
    // Choix de l'adresse de faturation
    onChangeselectedFacturation() {
      this.$invoice.client.adresseFacturation = ''
      console.log(this.clientSelect.adresses[this.selectedFacturation]);
      this.$invoice.client.adresseFacturation = {
        adresse1: this.clientSelect.adresses[this.selectedFacturation].adresse1,
        adresse2: this.clientSelect.adresses[this.selectedFacturation].adresse2,
        adresse3: this.clientSelect.adresses[this.selectedFacturation].adresse3,
        codepostal: this.clientSelect.adresses[this.selectedFacturation].codepostal,
        ville: this.clientSelect.adresses[this.selectedFacturation].ville,
        departement: this.clientSelect.adresses[this.selectedFacturation].departement,
        pays: this.clientSelect.adresses[this.selectedFacturation].pays,
      }
    },
    // Choix du contact
    onChangeselectedContact() {
      this.$invoice.client.email = ''
      let newContact
      // Nouveau contact : champs vides à remplir manuellement
      if (this.selectedContact === -1 || this.selectedContact === '') {
        newContact = {
          nom: '',
          prenom: '',
          email: '',
          telephone: '',
          portable: '',
        }
      } else if (this.clientSelect.contacts && this.clientSelect.contacts[this.selectedContact]) {
        console.log(this.clientSelect.contacts[this.selectedContact]);
        const c = this.clientSelect.contacts[this.selectedContact]
        newContact = {
          nom: c.nom || '',
          prenom: c.prenom || '',
          email: c.email || '',
          telephone: c.telephone || '',
          portable: c.portable || '',
        }
        this.$invoice.client.email = c.email
      } else {
        const cur = this.$invoice.client.contact
        newContact = {
          nom: (cur && cur.nom) ?? '',
          prenom: (cur && cur.prenom) ?? '',
          email: (cur && cur.email) ?? '',
          telephone: (cur && cur.telephone) ?? '',
          portable: (cur && cur.portable) ?? '',
        }
      }
      // $set pour forcer la réactivité Vue (affichage correct sur tous les navigateurs/PC)
      this.$set(this.$invoice.client, 'contact', newContact)
    },
    runArticleFind(selector) {
      const gen = ++this.articleSearchGeneration
      this.products = []
      this.totalRows = 0
      return this.localDB.find({ selector }, (err, doc) => {
        if (gen !== this.articleSearchGeneration) return
        this.setSearchArticles(err, doc, gen)
      })
    },
    // Choix de la collection
    async onChangeCategoryArticles(events) {
      if (this.selectedFournisseur.value) {
        await this.runArticleFind({
          type: 'articles',
          inactif: 0,
          categorie: this.selectedCategoriesArticle.value,
          fournisseur: this.selectedFournisseur.value,
        })
      } else {
        await this.runArticleFind({
          type: 'articles',
          inactif: 0,
          categorie: this.selectedCategoriesArticle.value.toString(),
        })
      }
    },
    // Choix de la marque
    async onChangeFournisseurs(events) {
      if (this.selectedCategoriesArticle.value) {
        await this.runArticleFind({
          type: 'articles',
          inactif: 0,
          categorie: this.selectedCategoriesArticle.value,
          fournisseur: this.selectedFournisseur.value,
        })
      } else {
        await this.runArticleFind({
          type: 'articles',
          inactif: 0,
          fournisseur: this.selectedFournisseur.value.toString(),
        })
      }
    },
    // Choix mode de paiement
    async onChangeModepaiement(events) {
      this.$invoice.client.modepaiement = this.selectedModepaiement.value
    },
    // Choix commerciaux
    async onChangeCommerciaux(events) {
      console.log(this.listcommerciaux.find(l => l.email === this.selectedCommerciaux.value).nom)
      this.$invoice.commercial = this.selectedCommerciaux.value
      this.$invoice.nomcommercial = this.listcommerciaux.find(l => l.email === this.selectedCommerciaux.value).nom + ' ' + this.listcommerciaux.find(l => l.email === this.selectedCommerciaux.value).prenom
      this.$invoice.telcommercial = this.listcommerciaux.find(l => l.email === this.selectedCommerciaux.value).phone
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    applyFilter() {
      if (this.filterInput.length >= 3) {
        this.filter = this.filterInput
      } else {
        this.filter = ''
      }
    },
    applyFilterEnter() {
      this.filter = this.filterInput
    },
    // SAVE invoiceData onglet Client
    validationClient() {
      return new Promise((resolve, reject) => {
        this.$refs.simpleRules.validate().then(success => {
          if (success && this.$invoice.datelivraison && this.$invoice.client.adresseLivraison.adresse1 && this.$invoice.client.adresseLivraison.codepostal && this.$invoice.client.adresseLivraison.ville && this.$invoice.client.adresseFacturation.adresse1 && this.$invoice.client.adresseFacturation.codepostal && this.$invoice.client.adresseFacturation.ville) {

            console.log('invoiceData', this.$invoice)

            resolve(true)
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Erreur de saisie',
                icon: 'CoffeeIcon',
                variant: 'warning',
                text: 'Merci de renseigner les champs reqis',
              },
            })
            reject()
          }
        })
      })
    },
    // SAVE invoiceData onglet article
    validationProduct() {
      var errorProduct = 1
      this.$invoice.products.forEach((value, index) => {
        if(value.variants != undefined && value.variant == undefined ) {
          errorProduct = 0
        }        
      });  
      // this.invoiceData = this.$invoice
      console.log('invoiceData', this.$invoice)
      if (errorProduct == 0) {
        console.log('ERROR')
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erreur de saisie',
            icon: 'CoffeeIcon',
            variant: 'warning',
            text: 'Merci de renseigner les champs reqis',
          },
        })
      }
      else { return true; }

    },
    // VALIDATION de la commande
    async formSubmitted() {

      if ((this.$invoice.consent != 'oui' && this.$refs.signaturePad.isEmpty()) || (this.$invoice.consent == 'oui' && !this.$refs.signaturePad.isEmpty())) {
        this.$invoice._id = uuidv4()
        this.$invoice.type = 'commandes'
        this.$invoice.datecreation = moment().format('YYYY-MM-DDTHH:mm:ss')
        this.$invoice.datemodif = moment().format('YYYY-MM-DDTHH:mm:ss')
        this.$invoice.sign = this.$refs.signaturePad.saveSignature()

        if (this.$invoice.consent == 'oui' && !this.$refs.signaturePad.isEmpty()) {
          this.$invoice.statut = 'Valider'
        }
        else {
          this.$invoice.statut = 'En cours'
        }

        console.log('Validation', JSON.stringify(this.$invoice))

        //Création de la commande
        await this.localDB.put(this.$invoice, (err, response) => {
          if (err) {
            console.log('errvalidation', err);
          } else {
            delete this.$invoice._id
            delete this.$invoice.type
            delete this.$invoice.datecreation
            delete this.$invoice.datemodif
            delete this.$invoice.datecommande
            delete this.$invoice.datelivraison
            delete this.$invoice.client.idclient
            delete this.$invoice.client.nom
            delete this.$invoice.client._id
            delete this.$invoice.sign
            delete this.$invoice.statut

            Vue.prototype.$invoice = Vue.observable({
              client: {
                adresseLivraison: '',
                adresseFacturation: '',
                email: '',
                contact: '',
              },
              products: [],
              totalmontant: 0,
              totalmontanttva: 0,
              totalmontantttc: 0,
              remisepanier: 0,
              consent: '',
              note: '',
              nomcommercial: '',
              commercial: '',
              telcommercial: ''
            })

            console.log('$invoice', this.$invoice)

            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Commande enregistrée',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Votre commande a été enregistré',
              },
            })

            this.localDB.sync(this.remoteDB)
              .on('complete', complete => {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Commande syncronisée',
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: 'Votre commande a été syncronisée',
                  },
                })
                this.$router.push({ name: 'listcommande' })
              })
              .on('error', err => {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Problème de synchronisation',
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: 'Impossible de synchronisée la commande',
                  },
                })
              })
          }
        })
      }
      else {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Acceptation de commande',
            icon: 'CoffeeIcon',
            variant: 'warning',
            text: 'Merci d\'accepter les générales de vente et de signer la commande',
          },
        })
      }

    },
    // Ajout information article suite au select article
    updateItemForm(index, val) {
      // console.log('update', val)
      console.log('index', this.$invoice.products[index])
      this.$invoice.products[index].codearticle = val.codearticle
      this.$invoice.products[index].conditionnement = val.conditionnement
      this.$invoice.products[index].image = val.image
      this.$invoice.products[index].variant = val.variant
      // Copie profonde pour éviter le partage de références entre lignes
      this.$invoice.products[index].variants = val.variants ? JSON.parse(JSON.stringify(val.variants)) : val.variants
      this.$invoice.products[index].gammes = val.gammes ? JSON.parse(JSON.stringify(val.gammes)) : val.gammes
      this.$invoice.products[index].prix = val.prix
      this.$invoice.products[index].prixpack = parseFloat(val.prix * parseInt(val.conditionnement)).toFixed(2)
      this.$invoice.products[index].quantitepack = 0
      this.$invoice.products[index].quantite = val.quantite
      if (typeof val.variant !== 'undefined') {
        this.$invoice.products[index].nom = val.variant
      }
      else {
        this.$invoice.products[index].nom = val.nom
      }
      this.$invoice.products[index].remise = val.remise
      this.$invoice.products[index].tva = val.tva
    },
    onChangeselectedVariant(event, item, index) {
      var indexArr = item.variants.findIndex(x => x.codearticle === event)

      this.$invoice.products[index].codearticle = item.codearticle
      this.$invoice.products[index].conditionnement = item.conditionnement
      this.$invoice.products[index].image = item.image
      this.$invoice.products[index].variant = item.variant
      // Copie profonde pour éviter le partage de références entre lignes
      this.$invoice.products[index].variants = item.variants ? JSON.parse(JSON.stringify(item.variants)) : item.variants
      this.$invoice.products[index].gammes = item.gammes ? JSON.parse(JSON.stringify(item.gammes)) : item.gammes
      this.$invoice.products[index].prix = item.prix
      this.$invoice.products[index].prixpack = parseFloat(item.prix * parseInt(item.conditionnement)).toFixed(2)
      this.$invoice.products[index].quantitepack = 0
      this.$invoice.products[index].quantite = 0 //item.quantite
      if (typeof item.variant !== 'undefined') {
        this.$invoice.products[index].nom = item.variants[indexArr].libelle
      }
      else {
        this.$invoice.products[index].nom = item.nom
      }
      this.$invoice.products[index].remise = item.remise
      this.$invoice.products[index].tva = item.tva
    },
    // Calcul des quantités
    onchangeQuantite(item, index) {
      // console.log(item);
      // console.log(index);
      let quantiteCalc = 0
      item.gammes.forEach(element => {
        quantiteCalc += parseInt(element.value)
      });
      // this.invoiceData.products[index].quantite = quantiteCalc
      this.$invoice.products[index].quantite = quantiteCalc
    },
    onchangequantitepacks(item, index) {
      console.log(item);
      console.log(index);
      console.log(item.quantitepack);
      let quantiteCalc = 0;
      quantiteCalc = parseInt(item.conditionnement) * parseInt(item.quantitepack);
      this.$invoice.products[index].quantite = quantiteCalc
    },
    // Vérifie si la quantité correspond à un conditionnement ou une somme de conditionnements
    isValidConditionnement(quantite, conditionnement) {
      if (!conditionnement || !quantite || quantite <= 0) {
        return false
      }
      
      // Parser le conditionnement en tableau de nombres
      const conditionnements = conditionnement.split(';')
        .map(c => parseInt(c.trim()))
        .filter(c => !isNaN(c) && c > 0)
      
      if (conditionnements.length === 0) {
        return false
      }
      
      const quantiteInt = parseInt(quantite)
      
      // Vérifier si la quantité correspond exactement à un conditionnement
      if (conditionnements.includes(quantiteInt)) {
        return true
      }
      
      // Vérifier si la quantité peut être formée en additionnant plusieurs conditionnements (avec répétition)
      // Utilisation d'une approche de programmation dynamique
      const dp = new Array(quantiteInt + 1).fill(false)
      dp[0] = true
      
      for (let i = 1; i <= quantiteInt; i++) {
        for (const cond of conditionnements) {
          if (i >= cond && dp[i - cond]) {
            dp[i] = true
            break
          }
        }
      }
      
      return dp[quantiteInt]
    },
    // Ajout d'une ligne produit
    addNewItemInItemForm() {
      this.$refs.form.style.overflow = 'hidden'
      this.$invoice.products.push(JSON.parse(JSON.stringify(this.itemFormBlankItem)))

      console.log('addNewItemInItemForm', this.$invoice.products);

    },
    selectedCol(item) {
      console.log('item', item)
      this.$refs.form.style.overflow = 'hidden'
      this.$invoice.products.push({
        codearticle: item.codearticle,
        prix: item.prix,
        quantite: 0,
        nom: item.nom,
        conditionnement: item.conditionnement,
        image: item.image,
        variant: item.variant,
        // Copie profonde pour éviter le partage de références entre lignes
        variants: item.variants ? JSON.parse(JSON.stringify(item.variants)) : item.variants,
        gammes: item.gammes ? JSON.parse(JSON.stringify(item.gammes)) : item.gammes,
        tva: item.tva,
        remise: 0,
      })

      this.$refs['modalarticle'].hide()

    },
    // Suppression d'une ligne produit
    removeItem(index) {
      this.$invoice.products.splice(index, 1)
    },
    clearSignature() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature()
      }
      this.$invoice.sign = null
    },
    eraseInvoice() {
      console.log('erase');
      this.selectedClient = []
      this.selectedLivraison = ''
      this.optionsLivraison = []
      this.selectedFacturation = ''
      this.optionsFacturation = []
      this.selectedContact = ''
      this.optionsEmail = []
      this.products = []

      this.$invoice.totalmontant = 0
      this.$invoice.totalfraisport = 0
      this.$invoice.totalmontanttva = 0
      this.$invoice.totalmontantttc = 0
      this.$invoice.totalPaire = 0

      delete this.$invoice._id
      delete this.$invoice.type
      delete this.$invoice.datecreation
      delete this.$invoice.datemodif
      delete this.$invoice.datecommande
      delete this.$invoice.datelivraison
      delete this.$invoice.client.idclient
      delete this.$invoice.client.nom
      delete this.$invoice.client._id
      delete this.$invoice.client.modepaiement
      delete this.$invoice.client.eligibleTVA
      delete this.$invoice.sign
      delete this.$invoice.statut

      delete this.$invoice.totalmontant
      delete this.$invoice.totalfraisport
      delete this.$invoice.totalmontanttva
      delete this.$invoice.totalmontantttc
      delete this.$invoice.totalPaire

      delete this.$invoice.products


      Vue.prototype.$invoice = Vue.observable({
        client: {
          adresseLivraison: '',
          adresseFacturation: '',
          email: '',
          contact: '',
        },
        products: [],
        totalmontant: 0,
        totalmontanttva: 0,
        totalmontantttc: 0,
        remisepanier: 0,
        totalPaire: 0,
        consent: '',
        note: '',
        nomcommercial: '',
        commercial: '',
        telcommercial: ''
      })

      this.initializeArticles()

      console.log(this.$invoice);

      this.$router.currentRoute
    }
  },
}
</script>



<style>
.signature {
  border: 1px solid #cbc9c6;
  border-radius: 5px;
}

.btn-primary {
  margin-right: 12px;
}

.per-page-selector {
  width: 90px;
}

.btNopadding button {
  padding: 0;
}

@media (max-width: 767.98px) {
  .table.b-table.b-table-stacked-md>tbody>tr>[data-label]::before {
    text-align: left;
  }
}

.input-valid-conditionnement {
  background-color: #d4edda !important;
  border-color: #28a745 !important;
  color: #155724 !important;
}

.input-invalid-conditionnement {
  background-color: #f8d7da !important;
  border-color: #dc3545 !important;
  color: #721c24 !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  overflow: initial !important;
  transition: .35s height;
}

.v-select {

  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }

  }
}
</style>
